// sportsConfig.js
import * as cricketStats from "./cricket";
import * as kabaddiStats from "./kabaddi";
import * as nbaStats from "./nba";

export const sportsConfig = {
  cricket: {
    batsman: cricketStats.batsmanStats,
    bowler: cricketStats.bowlerStats,
    allRounder: cricketStats.allRounder,
    wicketKeeper: cricketStats.wicketKeeper,
  },
  kabaddi: {
    raider: kabaddiStats.raiderStats,
    defender: kabaddiStats.defenderStats,
    allRounder: kabaddiStats.allRounderStats,
  },
  nba: {
    pointGuard: nbaStats.pointGuardStats,
    shootingGuard: nbaStats.shootingGuardStats,
    smallForward: nbaStats.smallForwardStats,
    powerForward: nbaStats.powerForwardStats,
    center: nbaStats.centerStats,
  }
  // ... configurations for other sports
};

export const nbaPositionMapping = {
  PG: sportsConfig.nba.pointGuard,
  SG: sportsConfig.nba.shootingGuard,
  SF: sportsConfig.nba.smallForward,
  PF: sportsConfig.nba.powerForward,
  C: sportsConfig.nba.center,
};

export const kabaddiPositionMapping = {
  AR: sportsConfig.kabaddi.allRounder,
  RA: sportsConfig.kabaddi.raider,
  DEF: sportsConfig.kabaddi.defender,
};

export const cricketPositionMapping = {
  AR: sportsConfig.cricket.allRounder,
  BAT: sportsConfig.cricket.batsman,
  BOWL: sportsConfig.cricket.bowler,
  WK: sportsConfig.cricket.wicketKeeper,
};
export const sportPositionMapping = {
  CRICKET: cricketPositionMapping,
  KABADDI: kabaddiPositionMapping,
  BASKETBALL: nbaPositionMapping,
};
export const nbaPlayerPositions = [
  {
    display_name: "ALL",
    description: "All players",
  },
  {
    display_name: "PG",
    description: "Point Guard",
  },
  {
    display_name: "SG",
    description: "Shooting Guard",
  },
  {
    display_name: "SF",
    description: "Small Forward",
  },
  {
    display_name: "PF",
    description: "Power Forward",
  },
  {
    display_name: "C",
    description: "Center",
  },
];
export const cricketPlayerPositions = [
  {
    display_name: "ALL",
    description: "All players",
  },
  {
    display_name: "WK",
    description: "Wicket Keepers",
  },
  {
    display_name: "BAT",
    description: "Batsmen",
  },
  {
    display_name: "AR",
    description: "All Rounders",
  },
  {
    display_name: "BOWL",
    description: "Bowlers",
  },
];

export const kabaddiPlayerPositions = [
  {
    display_name: "ALL",
    description: "All players",
  },
  {
    display_name: "DEF",
    description: "Defenders",
  },
  {
    display_name: "RA",
    description: "Raiders",
  },
  {
    display_name: "AR",
    description: "All Rounders",
  },
];

const sportPlayerPositions = {
  CRICKET: cricketPlayerPositions,
  KABADDI: kabaddiPlayerPositions,
  BASKETBALL: nbaPlayerPositions,
};

export const getSportPlayerPositions = (sport) => {

  return sportPlayerPositions[sport];
};
